module.exports = __webpack_public_path__ + "media/images/circle-reservartion-49cba9c704710beb9dd43423e70e3be2.svg";